import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c65c1ca&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c65c1ca')) {
      api.createRecord('5c65c1ca', component.options)
    } else {
      api.reload('5c65c1ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c65c1ca&", function () {
      api.rerender('5c65c1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/db/page-public/index.vue"
export default component.exports